<template>
  <div class="default-engineering-modules-header__column-icons no-internal-print">
    <button
      v-b-tooltip.hover.bottom="item.tooltip"
      v-for="(item, index) in icons"
      :key="index"
      @click="item.click"
    >
      <span class="material-icons-round" :class="item.class">
        {{ item.icon }}
      </span>
    </button>
    <s-sidebar v-if="showTreeviewIcon" icon="account_tree">
      <template #body>
        <treeview
          :tree="tree.nodes"
          :selected-id="assetId"
          @onClickNode="onClickNodeHandler"
        />
      </template>
    </s-sidebar>
    <s-modal
      v-model="showModalNotification"
      :title="$t('general.notification-modal')"
      ok-only
      size="lg"
      :ok-title="$t('general.ok')"
      @ok="closeModal"
    >
      <b-container fluid class="notification-modal">
        <b-list-group>
          <template v-for="(notification, index) in notifications">
            <b-list-group-item :key="index" class="bg-transparent" flat>
              <div v-html="notification.description"></div>
            </b-list-group-item>
          </template>
        </b-list-group>
      </b-container>
    </s-modal>
  </div>
</template>

<script>
import eventBus from '@/services/globalEventBus';
import events from '@/domain/events/engineeringModulesHeader';
import IconsHeaderMixin from '@/components/header/mixin/iconsHeaderMixin';
import Treeview from '@/components/treeview/Treeview';
import print from '@/services/print';
import treeviewInjectionMixin from '@/components/treeview/assetTreeviewInjectionMixin';
import loadingMixin from '@/services/loadingMixin';

export default {
  components: {
    Treeview,
  },
  mixins: [IconsHeaderMixin, treeviewInjectionMixin, loadingMixin],
  data: () => ({
    showModalNotification: false,
  }),
  computed: {
    assetId() {
      const { assetId } = this.$route.params;
      return assetId;
    },
    showNotificationIcon() {
      return this.notifications.length > 0;
    },
    icons() {
      const result = [
        {
          icon: 'warning',
          click: this.showModal,
          show: this.showNotificationIcon,
          class: 'default-engineering-modules-header__notification',
          tooltip: this.$t('buttons.notifications'),
        },
        {
          icon: 'autorenew',
          click: this.refresh,
          show: this.showUpdateIcon,
          class: {
            'default-engineering-modules-header__loading': this.loading,
          },
          tooltip: this.$t('buttons.refresh'),
        },
        {
          icon: 'wifi',
          click: this.wifi,
          show: this.showWifiIcon,
          tooltip: this.$t('buttons.network-status'),
        },
        {
          icon: 'info',
          click: this.info,
          show: this.showInfoIcon,
          tooltip: this.$t('buttons.active-info'),
        },
        {
          icon: 'print',
          click: this.print,
          show: this.showPrintIcon,
          tooltip: this.$t('buttons.print'),
        },
      ];
      return result.filter(x => x.show);
    },
  },
  methods: {
    showModal() {
      this.showModalNotification = true;
    },
    closeModal() {
      this.showModalNotification = false;
    },
    getEvent(event) {
      return {
        wait: (promise) => {
          this.startLoading();
          return promise
            .then(() => {
              this.endLoading();
            })
            .catch((error) => {
              this.endLoading();
              return Promise.reject(error);
            });
        },
        originalEvent: event,
      };
    },
    info() {
      eventBus.emit(events.info);
    },
    refresh(event) {
      eventBus.emit(this.updateEvent, this.getEvent(event));
    },
    wifi() {
      eventBus.emit(events.wifi);
    },
    print,
  },
};
</script>

<style lang="sass" scoped>
@-webkit-keyframes rotation
  from
    transform: rotate(0deg)
  to
    transform: rotate(359deg)
.default-engineering-modules-header
  &__notification
    color: var(--color-danger) !important

.default-engineering-modules-header
  &__loading
    animation: rotation 2s infinite linear

  &__column-icons
    & button
      border: none
      background-color: transparent
      outline: none
      & span
        color: var(--color-border-gray)

.notification-modal
  max-height: 50vh
  overflow: auto
</style>
